<template>
	<v-card height="100%">
		<component
			:is="wizard"
			v-if="wizard"
			ref="wizard"
			:device="device"
			@close="$emit('close')"
		></component>
		<v-dialog v-model="dialog" persistent max-width="290">
			<v-card v-if="popupData">
				<v-card-title>{{ popupData.title }}</v-card-title>
				<v-card-text>{{ popupData.text }}</v-card-text>
				<v-card-actions>
					<v-btn
						v-if="popupData.button"
						color="primary"
						text
						@click="popupButton"
						>{{ popupData.button }}</v-btn
					>
					<v-spacer />
					<v-btn text @click="popupClose">Close</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import { mapState } from "vuex";

import { DEVICE_CLASS_ALEXA } from "@/utils/k4util";

export default {
	// FUTURE: this becomes a npm module to keep wizard code isolated and independently tested

	props: {
		device: Object,
	},

	data: () => ({
		wizard: null,
	}),

	computed: {
		...mapState("wizard", ["popupData"]),

		dialog() {
			return !!this.popupData;
		},
	},

	watch: {
		device(val) {
			this.load();
		},
	},

	async created() {
		await this.load();
	},

	methods: {
		async load() {
			if (!this.device) {
				this.wizard = null;
				return this.$store.dispatch("wizard/reset");
			}

			const meta = this.device.description
				? this.device.description.meta
				: this.device.meta;

			let type;

			// if the device has a bridge property, start with using its type (should only ever have one)
			if (
				meta.properties &&
				meta.properties.bridge &&
				Array.isArray(meta.properties.bridge.options)
			) {
				type = meta.properties.bridge.options[0];
			} else if (_.startsWith(meta.cls, DEVICE_CLASS_ALEXA)) {
				type = "alexa";
			}

			// FUTURE: lookup other ways

			this.wizard = await this.build(this.device, type);
		},

		async build(device, type) {
			// dynamic component to keep size down. Webpack will chunk.
			switch (type) {
				case "alexa":
					return Vue.component("wizard", () => import("./Alexa"));
				case "zwave":
					return Vue.component("wizard", () => import(`./ZWave`));
				default:
					this.$log(`Wizard: Not found for device ${device.path}`);
					return Vue.component("wizard", () => import(`./NotFound`));
			}
		},

		// call to close wizard from outside
		async close() {
			// if wizard implements stop function, call it
			if (this.$refs.wizard && typeof this.$refs.wizard.stop === "function") {
				await this.$refs.wizard.stop();
			}

			this.$emit("close");
		},

		// manage popups for pairing wizards (confirmation, retry)
		popupClose() {
			this.popupData.resolve();
			this.$store.dispatch("wizard/hidePopup");
		},

		popupButton() {
			this.popupData.resolve(true);
			this.$store.dispatch("wizard/hidePopup");
		},
	},
};
</script>
